<template>
  <section>
    <div class="container">
      <custom-title-block class="color-white" :title="title" />
      <recruiting-content-block :steps="steps" />
      <custom-button-join :is-white="isWhite" />
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import RecruitingContentBlock from "@/components/main/recruinigProcess/modules/RecruitingContentBlock.vue";
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";

export default {
  name: "recruiting-process",
  components: {
    CustomButtonJoin,
    RecruitingContentBlock,
    CustomTitleBlock,
  },
  data() {
    return {
      isWhite: true,
      title: "ПРОЦЕС РЕКРУТИНГУ",
      steps: [
        {
          id: 1,
          step: "01",
          title: "Подай заявку",
          content: [
            {
              id: 1,
              step: "-",
              text: "гаряча лінія",
            },
            {
              id: 2,
              step: "-",
              text: "анкета на сайті",
            },
            {
              id: 3,
              step: "-",
              text: "work.ua",
            },
            {
              id: 4,
              step: "-",
              text: "lobbyx.army",
            },
            {
              id: 5,
              step: "-",
              text: "robota.ua",
            },
          ],
          description: [],
        },
        {
          id: 2,
          step: "02",
          title: "Пройди відбір",
          content: [
            {
              id: 1,
              step: "2.1",
              text: "Співбесіда",
            },
            {
              id: 1,
              step: "2.2",
              text: "Тестування",
            },
          ],
          description: ["При негативному результаті дані в ТЦК НЕ ПЕРЕДАЮТЬСЯ"],
        },
        {
          id: 3,
          step: "03",
          title: "Обери підрозділ",
          content: [
            {
              id: 1,
              step: "",
              text:
                "Дізнайтеся більше про підрозділи, які шукають людей, " +
                "та майте можливість зробити важливий, усвідомлений вибір",
            },
          ],
          description: [],
        },
        {
          id: 4,
          step: "04",
          title: "Оформлення на контракт",
          content: [
            {
              id: 1,
              step: "4.1",
              text: "Отримай чіткий алгоритм дій",
            },
            {
              id: 2,
              step: "4.2",
              text: "Супровід на всіх етапах",
            },
          ],
          description: [],
        },
        {
          id: 5,
          step: "05",
          title: "Пройди навчання",
          content: [
            {
              id: 1,
              step: "5.1",
              text: "Базова загальновійськова підготовка в спеціалізованому центрі",
            },
            {
              id: 2,
              step: "5.2",
              text: "Фахове навчання",
            },
            {
              id: 3,
              step: "5.3",
              text: "Отримання військової спеціальності (ВОС - 216, ВОС-603)",
            },
          ],
          description: [],
        },
        {
          id: 6,
          step: "06",
          title: "Доєднайся до обраного підзрозділу",
          content: [
            {
              id: 1,
              step: "",
              text:
                "Дізнайтеся більше про підрозділи, які шукають людей, та " +
                "майте можливість зробити важливий, усвідомлений вибір.",
            },
          ],
          description: [],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  background: #1c1c1c;
  color: white;
  padding: 50px;

  @media (max-width: 767px) {
    padding: 50px 0;
  }

  .container {
    margin-top: 0 !important;
  }
}
</style>
